import Vue from 'vue'
import './plugins/axios'
import dayjs from 'dayjs'
import router from './router'
import store from './store'
import './assets/css/assembly-css.min.css';
import './assets/css/style/theme/index.css';
import './plugins/element.js'
import './assets/icon/iconfont.css'
import './plugins/directives.js'
import i18n from './i18n'
import HOST from '@/api/fileApi';
import VueMeta from 'vue-meta';
//富文本
import VueClipboard from 'vue-clipboard2'
//import VueQuillEditor from 'vue-quill-editor'
import 'babel-polyfill';
 
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
import check from '@/check/check'
import Format from './utils/tool'
//mydev
import api from './api/api.js'
import socketio from 'socket.io-client';
import VueSocketio from 'vue-socket.io';
import Vant from 'vant';
import 'vant/lib/index.css';
import jscookie from "js-cookie";
//mydev 
 // window.document.cookie ="auto_token=1222";
 let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
 if(flag && location.pathname!='/index/wantOrder' && location.pathname!='/purchase/add' && location.pathname!='/index/checkOrder'){
	  location.href="/";
 }

const tool = {
    install(Vue){
        Vue.prototype.$tool = Format
    }
}
Vue.use(tool);
Vue.use(Vant);
Vue.use(VueMeta);
Vue.prototype.$api = api;
Vue.prototype.$flag = flag;
 // Vue.use(new VueSocketio({
 //     debug: true,
 //     connection: socketio.connect('ws://ws.inspector.ltd', {
         
 //         transports: ['websocket'],
 //     })
 // }));
 // Vue.prototype.$socketio = socketio;
//Vue.use(VueQuillEditor)

// 滚屏滑动
// import vueAwesomeSwiper from 'vue-awesome-swiper'
// Vue.use(vueAwesomeSwiper);

// 引入国际化
// import ElementUI from 'element-ui'
// import locale from 'element-ui/lib/locale/lang/en'
// Vue.use(ElementUI, { locale })

// 全局 Mixin
import { MIXIN as TableMixin } from '@/mixins/tableMixin';
Vue.mixin(TableMixin);

//高德地图
// import VueAMap from 'vue-amap';
// Vue.use(VueAMap);
// VueAMap.initAMapApiLoader({
//   key: 'd966e12dc1e2f72cd39d5a5c22aeaf56',
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor','AMap.Geolocation'],
//   // 默认高德 sdk 版本为 1.4.4
//   v: '1.4.4'
// });
/*
// 百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key 
  ak: 'timuI9Ae9CEC3FWENzvDT3G6hTfm11o2'
})
*/
// 高德地图
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {

  load: {

    key: 'AIzaSyCF9by0sIxwGZT11jMSdv0whRSxnddsaII',

    libraries: 'places', // This is required if you use the Autocomplete plugin

    // OR: libraries: 'places,drawing'

    // OR: libraries: 'places,drawing,visualization'

    // (as you require)

    //// If you want to set the version, you can do so:

    // v: '3.26',

  },

  //// If you intend to programmatically custom event listener code

  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)

  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)

  //// you might need to turn this on.

  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.

  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'

  //// Vue.component('GmapMarker', GmapMarker)

  //// then disable the following:

  // installComponents: true,

})
// 百度站点统计


// 全局组件
import SubMenu from "@/components/SubMenu.vue"
import Pagination from '@/components/pagination'
import 'animate.css';
/* import 'vue-fullpage/vue-fullpage.css'
import VueFullpage from 'vue-fullpage'
Vue.use(VueFullpage) */
// 全屏测试
import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
// import VueFullPage from 'vue-fullpage.js'
import 'hover.css';
import 'wowjs/css/libs/animate.css';
require("./assets/js/world.js");
require("./assets/js/china.js");

// Vue.use(VueFullPage);
Vue.use(VueClipboard)
import App from './App.vue'
Vue.component('SubMenu', SubMenu)
Vue.component("Pagination", Pagination)
Vue.config.productionTip = false
Vue.prototype.$host = HOST;
Vue.prototype.$check = check;
  let vm=new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')

